import questionnaireRepository from '@/repositories/answerer/questionnaire.repository'

class QuestionnaireService {
  async callSaveQuestionnaire (params) {
    const data = await questionnaireRepository.callSaveQuestionnaire(params);
    return data || [];
  }
  async questionnaireInfo (assessmentId, language) {
    const data = await questionnaireRepository.questionnaireInfo(assessmentId, language);
    return data || [];
  }
  async questionnaireList () {
    const data = await questionnaireRepository.questionnaireList();
    return data || [];
  }
  async deleteQuestionnaire (updateAssessmentDtoStatus) {
    const data = await questionnaireRepository.deleteQuestionnaire(updateAssessmentDtoStatus);
    return data || [];
  }
  async confirmQuestionnaire (updateAssessmentDtoStatus) {
    const data = await questionnaireRepository.confirmQuestionnaire(updateAssessmentDtoStatus);
    return data || [];
  }
  async previewQuestionnaire (previewAssessmentId) {
    const data = await questionnaireRepository.previewQuestionnaire(previewAssessmentId);
    return data || [];
  }
  async findQuestionnaireResult () {
    const data = await questionnaireRepository.findQuestionnaireResult();
    return data || [];
  }
  async findQuestionnaireResultByConditions (params) {
    const data = await questionnaireRepository.findQuestionnaireResultByConditions(params);
    return data || [];
  }
  async findUserInfo (params) {
    const data = await questionnaireRepository.findUserInfo(params);
    return data || [];
  }
  async findSearchConditions () {
    const data = await questionnaireRepository.findSearchConditions();
    return data || [];
  }
  async callSendRemindEmail (sendReminderList) {
    const data = await questionnaireRepository.callSendRemindEmail(sendReminderList);
    return data || [];
  }
  async remindAllStakeholder (params) {
    const data = await questionnaireRepository.remindAllStakeholder(params);
    return data || [];
  }
  async callGenerateExcel (params) {
    const data = await questionnaireRepository.callGenerateExcel(params);
    return data || [];
  }
}
module.exports = new QuestionnaireService();



// WEBPACK FOOTER //
// ./src/services/answerer/questionnaire.service.js